import React from 'react';
import { Box } from '@mui/material';
import FieldingStatsTable from '../components/FieldingStatsTable';
import { API_ENDPOINTS } from '../config/api';

const CareerFieldingStatsPage = () => {
  return (
    <Box sx={{ p: 3 }}>
      <FieldingStatsTable apiUrl={API_ENDPOINTS.PLAYER_FIELDING_STATS} careerStats={true} />
    </Box>
  );
};

export default CareerFieldingStatsPage; 